/**
 * ops 工数ポイント（工数見積もり）の共有定数。TL が確定する 0–21 のスケール（Ryan の
 * operation-point-estimator の 1–21 に、対応不要かつ工数 0 分のケースを表す 0 を加えたもの）。
 * backend の検証・API スキーマと frontend の入力 UI が同じ範囲を参照する単一 source
 * （範囲の重複定義を防ぐ）。0 = 対応不要（工数 0。記録はするが Backlog 起票はしない）、
 * null = 見積もり待ち（未確定）。
 *
 * @graph-stack ops-core
 * @graph-domain Operations
 * @graph-business ops 工数ポイントの下限・上限（0–21）の単一 source。0=対応不要（工数0・非起票）。backend 検証 / API スキーマ / PIL 入力 UI が共有し範囲の drift を防ぐ
 * @graph-connects none
 */
/** 工数ポイントの下限（0＝対応不要・工数 0 分。記録のみで Backlog 非起票）。 @graph-connects none */
export const OPS_POINT_MIN = 0;
/** 工数ポイントの上限（21。Ryan の見積もりスケール上限）。 @graph-connects none */
export const OPS_POINT_MAX = 21;
/** Backlog 起票対象となる工数ポイントの下限（1。0=対応不要は起票しない）。 @graph-connects none */
export const OPS_POINT_BACKLOG_MIN = 1;
//# sourceMappingURL=point.js.map